import React, { useState } from 'react';

const EPrescriptionForm = () => {
  const [formData, setFormData] = useState({
    patientId: '',
    medicine: '',
    dosage: '',
    duration: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Prescription envoyée avec succès !');
  };

  return (
    <div className="p-4">
      <h1 className="mb-4">Prescription électronique</h1>
      <div className="card p-4">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Numéro patient</label>
            <input
              type="text"
              className="form-control"
              placeholder="CNAMGS-XXXXXXXX"
              value={formData.patientId}
              onChange={(e) => setFormData({...formData, patientId: e.target.value})}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Médicament</label>
            <input
              type="text"
              className="form-control"
              placeholder="Nom du médicament"
              value={formData.medicine}
              onChange={(e) => setFormData({...formData, medicine: e.target.value})}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Posologie</label>
            <input
              type="text"
              className="form-control"
              placeholder="Ex: 2 comprimés par jour"
              value={formData.dosage}
              onChange={(e) => setFormData({...formData, dosage: e.target.value})}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Durée (jours)</label>
            <input
              type="number"
              className="form-control"
              placeholder="7"
              value={formData.duration}
              onChange={(e) => setFormData({...formData, duration: e.target.value})}
            />
          </div>
          <button type="submit" className="btn btn-primary">Valider la prescription</button>
        </form>
      </div>
    </div>
  );
};

export default EPrescriptionForm;